/// <amd-module name="Test/ConfigurationToolbar/Actions/ConfigurationToolbarActionsCreator" />
import * as CommonTypes from "Test/Analytics/Common/Types";
import { ConfigurationToolbarActions } from "Test/ConfigurationToolbar/Actions/ConfigurationToolbarActions";
import { FilterMetadataActionsCreator } from "Test/MetadataHandler/Actions/FilterMetadataActionsCreator";

export class ConfigurationToolbarActionsCreator {
    constructor(private _actions: ConfigurationToolbarActions, private _filterMetadataActionCreator?: FilterMetadataActionsCreator) {}

    public updateConfigurationValues(testReportContext: CommonTypes.ITestReportContext, confValues: CommonTypes.IReportConfiguration): void {
        this._actions.updateConfigurationValuesAction.invoke(confValues);

        if (this._filterMetadataActionCreator && confValues.groupBy === CommonTypes.GroupBy.Environment) {
            this._filterMetadataActionCreator.updateReleaseDefinitionMetadata(testReportContext.definitionId);
        }
    }

    public onToggleFilter(): void {
        this._actions.onToggleFilter.invoke(null);
    }
}
